import { PowerBIEmbed } from "powerbi-client-react";
import { models, powerbi } from "powerbi-client";
import { Button } from "antd";
import "./EmbedReports.scss";
import { useRef, useState } from "react";
import { ServiceUtils } from "../../../Shared/Utils/ServiceUtils";
import { alertService } from "../../../Shared/Utils/ToasterUtils";
import { useNavigate } from "react-router-dom";
import { usePowerBITokenRefresh } from "./usePowerBITokenRefresh";

const EmbedReports = ({ embedUrl, repordId, token, workSpaceId, reportName,  expiration }) => {
  //  tokenExpiry => pass from backend
  const reportRef = useRef(null);
  const isMobile = window.innerWidth < 768;
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  const exportReport = () => {
    const payload = {
      report_id: repordId,
      workspaceID: workSpaceId,
      format: "PDF",
    };
    ServiceUtils.postBlobRequest("exportReport", payload).then(
      (response) => {
        if (response) {
          downloadReport(response);

          setLoader(false);
        } else if (response.status === 401) {
          navigate("/logout");
        } else {
          alertService.error(response.data.message);
        }
      },
      (error) => {
        alertService.error("Error while fetching data");
        console.log(error);
      }
    );
  };

  const downloadReport = (response) => {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = reportName + ".pdf";
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  };


  // 🔁 API call to get new token
  const getNewToken = async () => {
    const payload = {
        report_id: repordId,
        workspace_id: workSpaceId,
      }
    try {
      ServiceUtils.postRequest("refreshEmbedToken", payload).then((response) => {
        console.log("refresh token called")
        console.log(response,"response")
        if(response) {
          return {
            token: response?.data?.token,
            expiry: response?.data?.expiry,
          }
        }

      })
    } catch (err) {
      console.error("Token API failed", err);
      return {};
    }
  };

  // custom  hook integration
  const { handleError } = usePowerBITokenRefresh({
    reportRef,
    getNewToken,
    tokenExpiryTime: expiration,
  });


  return (
    <>
      <div style={{ padding: "5px", textAlign: "right" }}>
        <Button type="primary" onClick={exportReport}>
          Export Report
        </Button>
      </div>
      <PowerBIEmbed
        embedConfig={{
          type: "report",
          id: repordId,
          embedUrl,
          accessToken: token,
          tokenType: models.TokenType.Embed,
          settings: {
            layoutType: isMobile
              ? models.LayoutType.MobilePortrait
              : models.LayoutType.Master,
            panes: {
              filters: { visible: false },
              pageNavigation: { visible: true },
            },
          },
        }}
        getEmbeddedComponent={(report) => {
          reportRef.current = report;
        }}
        eventHandlers={
          new Map([
            ["loaded", () => console.log("Report loaded")],
            ["error", handleError], 
          ])
        }
        cssClassName="report-container"
      />
    </>
  );
};

export default EmbedReports;
